module.exports = __webpack_public_path__ + "static/media/garabage.b20ea7fd.svg";